import { useSetRecoilState } from 'recoil';
import history from 'service/customHistory';
import { RouteProps } from 'react-router-dom';

import ELEMENT from 'common/element';
import log from 'common/ScalyrLogger';
import Page from 'components/common/Page/Page';
import Button, { ButtonVariant } from 'components/common/Button/Button';
import { pageAlertConfigState } from 'components/common/PageAlert/PageAlert.state';

import './PageNotFound.scss';

export enum PAGE_VARIANT {
  PUBLIC = 'public',
  PRIVATE = 'private',
}

type PageNotFoundProps = {
  variant?: PAGE_VARIANT;
} & RouteProps;

function PageNotFound(props: PageNotFoundProps): JSX.Element {
  const { variant = PAGE_VARIANT.PRIVATE } = props;

  const setPageAlertConfig = useSetRecoilState(pageAlertConfigState);

  const goBack = (): void => {
    history.back();
  };
  const logMissingLink = (): void => {
    log.info(`Missing link reported: ${window.location.href}`);
    setPageAlertConfig({
      message: 'Thank you for reporting this URL as a broken link!',
      autoHide: true,
      duration: 5,
    });
  };

  return (
    <Page docTitle="Page Not Found" testId={ELEMENT.pageNotFound}>
      <div className="PageNotFound">
        <div className="PageNotFound__404">404</div>
        <div className="PageNotFound__SorryMessage">Sorry, page not found</div>
        <div>
          <Button
            className="PageNotFound__GoBackButton"
            onClick={goBack}
            variant={ButtonVariant.PRIMARY}
            testId={ELEMENT.pageNotFoundGoBackButton}
          >
            Go Back
          </Button>
        </div>
        {variant === PAGE_VARIANT.PRIVATE && (
          <div className="PageNotFound__BrokenLinkPrompt" data-test-id={ELEMENT.pageNotFoundPrivateBrokenLinkPrompt}>
            <a href="#" onClick={logMissingLink} data-test-id={ELEMENT.pageNotFoundPrivateReportButton}>
              Report broken link
            </a>
          </div>
        )}
        {variant === PAGE_VARIANT.PUBLIC && (
          <div className="PageNotFound__BrokenLinkPrompt" data-test-id={ELEMENT.pageNotFoundPublicBrokenLinkPrompt}>
            <div>Please contact Support for help.</div>
          </div>
        )}
      </div>
    </Page>
  );
}

export default PageNotFound;
